import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import banner from '../../images/TopBanner/banner.png';
import ellipse from '../../images/TopBanner/Ellipse.png';
import ict from '../../images/TopBanner/ict.png';
import ms from '../../images/TopBanner/Microsoft.png';
import arrow from '../../images/TopBanner/right-arrow.png';
import slack from '../../images/TopBanner/slack.png';
import thin from '../../images/TopBanner/thin.png';
import uber from '../../images/TopBanner/uber.png';
import './TopBanner.scss';

const TopBanner = () => (
    <section>
        <div className="upper-img-container">
            <div className="upper-img">
                <img src={thin} alt="" />
            </div>
        </div>
        <Container>
            <Row className="d-flex align-items-center">
                <Col md={6}>
                    <div className="banner-item1" data-aos="fade-right" data-aos-duration="2000">
                        <h1>
                            WordPress <br /> <img src={ellipse} className="img-ellipse" alt="Cut" />{' '}
                            Solutions <span>Delivered!</span>
                        </h1>
                        <p>
                            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
                            sint.{' '}
                        </p>
                        <div className="top-banner-btn1">
                            <button type="button" className="get-started">
                                Get Started <img src={arrow} alt="" />
                            </button>
                            <button type="button" className="ms-4 learn-more">
                                Learn more
                            </button>
                        </div>
                    </div>
                </Col>
                <Col md={6} data-aos="fade-up" data-aos-duration="2000">
                    <img src={banner} className="img-fluid" alt="" />
                    <div className="top-banner-btn">
                        <button type="button" className="get-started">
                            Get Started <img src={arrow} alt="" />
                        </button>
                        <br />
                        <br />
                        <button type="button" className="learn-more">
                            Learn more
                        </button>
                    </div>
                </Col>
            </Row>
            <div className="show-case-img" data-aos="zoom-in-up" data-aos-duration="2000">
                <img className="img-fluid" src={uber} alt="uber" />
                <img className="img-fluid" src={slack} alt="slack" />
                <img className="img-fluid" src={ms} alt="microsoft" />
                <img className="img-fluid" src={ict} alt="ict" />
            </div>
        </Container>
    </section>
);

export default TopBanner;
